const legalFormKeys = [
  {
    id: 10
  },
  {
    id: 21
  },
  {
    id: 22
  },
  {
    id: 23
  },
  {
    id: 31
  },
  {
    id: 41
  },
  {
    id: 42
  },
  {
    id: 43
  },
  {
    id: 49
  },
  {
    id: 51
  },
  {
    id: 53
  },
  {
    id: 54
  },
  {
    id: 55
  },
  {
    id: 61
  },
  {
    id: 62
  },
  {
    id: 63
  },
  {
    id: 71
  },
  {
    id: 72
  },
  {
    id: 81
  },
  {
    id: 82
  },
  {
    id: 83
  },
  {
    id: 84
  },
  {
    id: 87
  },
  {
    id: 88
  },
  {
    id: 89
  },
  {
    id: 92
  },
  {
    id: 93
  },
  {
    id: 94
  },
  {
    id: 95
  },
  {
    id: 96
  },
  {
    id: 98
  },
  {
    id: 99
  }
];

export default legalFormKeys;



// WEBPACK FOOTER //
// ./src/data/legalFormKeys.js